export default {
  home: 'Головна'
}
